module.exports = __webpack_public_path__ + "img/thumbnail_Gharial_f_albino.2955f907.png";